import {Component, inject} from '@angular/core';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {TranslatePipe} from '@ngx-translate/core';
import {FEATURE_FLAG, PERMISSION} from '@generated-backend-types';
import {UserSessionService} from '../../services/user-session-service/user-session.service';
import {IfHasAllPermissionsDirective} from '../../directives/if-has-all-permissions.directive';

@Component({
  selector: 'app-sidebar',
  imports: [
    RouterLinkActive,
    RouterLink,
    TranslatePipe,
    IfHasAllPermissionsDirective,
  ],
  templateUrl: './sidebar.component.html',
  standalone: true
})
export class SidebarComponent {
  private userSessionService = inject(UserSessionService);

  public readonly PERMISSION = PERMISSION;

  readonly showEvents = this.userSessionService.hasAllFeatureFlag(
    [FEATURE_FLAG.SERVICE_PROVIDER_HUB_EVENT_CENTRIC],
  );

  logout() {
    this.userSessionService.logout().subscribe();
  }
}
